import { ErrorDialog } from "@graffer-inc/console-design-kit";
import dayjs from "dayjs";
import { Formik, FormikProps } from "formik";
import { useProductDataRemovalTaskCreateForm } from "./form/hooks";
import {
  ProductDataRemovalTaskForm,
  ProductDataRemovalTaskFormValues,
} from "./form/product-data-removal-task-form";
import { ProductDataRemovableProductCodeLiterals } from "../../../../../application/domain/product-data-removal-task";

type ProductDataRemovalTaskCreateModalProps = {
  productCode: ProductDataRemovableProductCodeLiterals;
  tenantSlug: string;
  onProceed: (
    productCode: ProductDataRemovableProductCodeLiterals,
    dueAt: Date,
  ) => void;
  onCancel: () => void;
};

export const ProductDataRemovalTaskCreateModal = ({
  productCode,
  tenantSlug,
  onProceed,
  onCancel,
}: ProductDataRemovalTaskCreateModalProps) => {
  const { initialValues, validationSchema, dateConfig } =
    useProductDataRemovalTaskCreateForm({
      tenantSlug,
    });

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        const dueAt = dayjs(values.dueAt, dateConfig.DateFormat, true)
          .endOf("day")
          .toDate();
        onProceed(productCode, dueAt);
      }}
      validateOnChange={true}
      validateOnMount={true}
      enableReinitialize={true}
      validateOnBlur={true}
    >
      {(formikProps: FormikProps<ProductDataRemovalTaskFormValues>) => {
        const { isValid, submitForm } = formikProps;

        return (
          <ErrorDialog
            title="製品データ削除タスクの登録"
            proceedText="登録する"
            cancelText="やめる"
            proceedDisabled={!isValid}
            onProceed={submitForm}
            onCancel={onCancel}
            contents={
              <ProductDataRemovalTaskForm
                productCode={productCode}
                tenantSlug={tenantSlug}
                dueAtConfig={{
                  readOnly: false,
                  minDate: dateConfig.MinDate,
                  maxDate: dateConfig.MaxDate,
                }}
                formikProps={formikProps}
              />
            }
          />
        );
      }}
    </Formik>
  );
};
